import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from './Modal';
import { openModal, resetModal } from '../actions/modalsActions';
import i18n from '../utils/i18n';
import { modals } from '../utils/constants';
import ApiClient from "../utils/apiClient";

class FeedbackModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            content: '',
            errors: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.sendFeedback = this.sendFeedback.bind(this);
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState({[name]: value});
    }

    sendFeedback() {
        ApiClient.post('/api/v1/feedback/', {
            email: this.state.email,
            content: this.state.content,
        }).then(() => {
            this.props.openModal(modals.FEEDBACK_SENT);
        }).catch(() => {
            this.setState({errors: true})
        });
    }

    render() {
        const { isLoggedIn } = this.props.modalData;
        return (
            <Modal
                isOpen={true}
                onRequestClose={this.props.resetModal}
                closeButtonText={i18n.t('modals.feedback.CANCEL_BUTTON')}
                actionButtonText={i18n.t('modals.feedback.SEND_BUTTON')}
                actionFunction={() => this.sendFeedback()}
            >
                <div className="modal-container">
                    <h1 className="modal-header">
                        {i18n.t('modals.feedback.TITLE')}
                    </h1>
                    <div className="form-container">
                        { !isLoggedIn &&
                        <div className="form-group">
                            <label htmlFor="email">{i18n.t('modals.feedback.EMAIL_LABEL')}</label>
                            <input name="email"
                                   onChange={this.handleChange}
                                   value={this.state.email}
                                   className="private-data form-control"
                                   placeholder={i18n.t('modals.feedback.EMAIL_PLACEHOLDER')}/>
                        </div>
                        }
                        <div className="form-group">
                            <label htmlFor="content">{i18n.t('modals.feedback.CONTENT_LABEL')}</label>
                            <textarea name="content"
                                      className="form-control textarea-big"
                                      onChange={this.handleChange}
                                      value={this.state.content}
                                      placeholder={i18n.t('modals.feedback.CONTENT_PLACEHOLDER')}
                            />
                        </div>
                        {this.state.errors &&
                        <div className="text-danger">
                            {i18n.t('modals.feedback.SEND_ERROR')}
                        </div>
                        }
                    </div>
                </div>
            </Modal>
        );
    }
}

FeedbackModal.propTypes = {
    modalData: PropTypes.shape({
        isLoggedIn: PropTypes.bool,
    }),
    resetModal: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired
};

FeedbackModal.defaultProps = {
    modalData: {
        isLoggedIn: false,
    }
};

const mapStateToProps = state => ({
    modalData: state.modals.modalData
});

const mapDispatchToProps = dispatch => ({
    resetModal: () => dispatch(resetModal()),
    openModal: (modal, modalData) => dispatch(openModal(modal, modalData)),
    dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackModal);



// WEBPACK FOOTER //
// ./src/modals/FeedbackModal.js